import { render, staticRenderFns } from "./NotificationDigestIcon.vue?vue&type=template&id=dc7af29e&"
import script from "./NotificationDigestIcon.vue?vue&type=script&lang=ts&"
export * from "./NotificationDigestIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports